import moment from 'moment';
import { Box } from '@chakra-ui/react';
import { useState } from 'react';

import { QueryTable } from '@app/components/common/table';
import { useApi, useFetchData } from '@app/hooks';
import { UserActivity } from '@app/api/models';
import { DateRangeField, Paper } from '@app/components/common';
import { DateRange } from '@app/components/common/date-range-picker/types';

import { useColumns } from './columns';


export const UserActivityTable = () => {
  const api = useApi();
  const columns = useColumns();  
  const [period, setPeriod] = useState<DateRange>({
    startDate: moment().subtract(7, 'day'),
    endDate: moment()
  });

  const [fetchData] = useFetchData({
    method: (payload) => api.reports.getUserActivity({
      ...payload,
      filter: {
        date_b: period.startDate.format('YYYY-MM-DD'),
        date_e: period.endDate.format('YYYY-MM-DD')
      },
    })
  });

  return <>
    <Box mb={2}>
      <Paper>
        <Box px={6} py={4} display="flex">
          <Box mr={2} minWidth={300}>
            <DateRangeField
              id='period'
              label="Период"
              value={period}
              onChange={setPeriod}
            />
          </Box>
        </Box>
      </Paper>
    </Box>
    <QueryTable<UserActivity>
      title="Пользовательская активность"
      columns={columns}
      fetchData={fetchData}
      key={`${period.startDate}-${period.endDate}`}
    />
  </>;
};